import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Divider } from '@coolblue-development/freddy';
import { useTranslation } from '../../i18n/useTranslation.js';
export function PickupOnlyAlert() {
    const { t } = useTranslation('storesStockOverlay.pickupOnly');
    return (_jsxs(_Fragment, { children: [_jsx(Alert, { title: t('title'), description: t('description') }), _jsx(Divider, { mt: 400, mb: 400 })] }));
}
//# sourceMappingURL=PickupOnlyAlert.js.map